export default "__VITE_ASSET__CXRJcJXG__"